import { LOGOUT } from '@plone/volto/constants/ActionTypes';
import { GET_MPF_PERMISSOES } from '../../constants';

const initialState = {
  data: null,
  error: null,
  loaded: false,
  loading: false,
};

/** Permissões de interface do usuário autenticado (`@mpf-permissoes`). */
export const mpfPermissoesReducer = (
  state = initialState,
  action: any = {},
) => {
  switch (action.type) {
    case `${GET_MPF_PERMISSOES}_PENDING`:
      return { ...state, error: null, loading: true };

    case `${GET_MPF_PERMISSOES}_SUCCESS`:
      return {
        ...state,
        data: action.result ?? null,
        error: null,
        loaded: true,
        loading: false,
      };

    case `${GET_MPF_PERMISSOES}_FAIL`:
      return {
        ...state,
        data: null,
        error: action.error,
        loaded: false,
        loading: false,
      };

    // Outra pessoa pode entrar no mesmo navegador: nada do anterior fica.
    case LOGOUT:
    case `${LOGOUT}_SUCCESS`:
      return initialState;

    default:
      return state;
  }
};

export default mpfPermissoesReducer;
